<template>
  <div>
    <div class="px-5 py-1 pb-8 border border-gray-400 border-solid my-2">
      <h4 class="text-left text-2xl font-bold my-6">
        Información del gestor de la modificación
      </h4>
      <hr />
      <div class="container mx-auto max-w-4xl px-4 mt-5">
        <div v-if="form.managed_data" class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Nombre completo"
              v-model="form.managed_data.full_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Correo electrónico"
              v-model="form.managed_data.email"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>
        <div v-if="form.managed_data" class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Tipo de identificación"
              v-model="form.managed_data.identification_type"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Número de identificación"
              v-model="form.managed_data.identification_number"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>

        <div v-else class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <p class="text-left">
              El usuario ingresó la información por su cuenta.
            </p>
          </div>
        </div>

        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Fecha de actualización"
              v-model="form.creation_date"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="px-5 py-1 pb-5 border border-gray-400 border-solid my-2 mt-10">
      <h4 class="text-left text-2xl font-bold my-6">
        Información del consumidor financiero
      </h4>
      <hr />

      <div class="container mx-auto max-w-4xl px-4 mt-5">
        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Nombres"
              v-model="form.first_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Apellidos"
              v-model="form.last_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>
        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Tipo de identificación"
              v-model="form.tipo_id_cf_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Número de identificación"
              v-model="form.numero_id_CF"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>
        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Fecha de nacimiento"
              v-model="form.birth_date"
              placeholder=""
              :disabled="true"
            />
            <BaseInput
              type="text"
              label="Dirección física"
              v-model="form.address"
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>
        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Número de teléfono"
              v-model="form.phone"
              placeholder=""
              :disabled="true"
            />
            <BaseInput
              type="text"
              label="Correo electrónico"
              v-model="form.email"
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>
        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Seleccione un departamento"
              v-model="form.department_name"
              placeholder=""
              :disabled="true"
            />
            <BaseInput
              type="text"
              label="Seleccione un municipio"
              v-model="form.municipio_name"
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $consumeService from "@/feature/historical/data/services/historical_impl";

export default {
  components: {},
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        tipo_id_CF: "",
        tipo_id_cf_name: "",
        numero_id_CF: "",
        birth_date: "",
        address: "",
        phone: "",
        email: "",
        department_name: "",
        municipio_name: "",
        creation_date: "",
      },
    };
  },
  mounted() {
    console.log(this.$route.params.idDetail);

    $consumeService
      .getHistoricalConsumDetail(this.$route.params.idDetail)
      .then(({ data }) => {
        const formData = data.data;
        // Si existe creation_date, reemplaza la T por un espacio
        if (formData.creation_date) {
          formData.creation_date = formData.creation_date.replace("T", " ");
        }

        this.form = formData;
      });
  },
  methods: {
    defineReturnActionLeft() {
      return this.form.type_problem_name;
    },
    defineReturnActionRight() {
      this.valuesStatus.filter((item) => {
        if (item.value === this.form.status) {
          this.status = item.color;
        }
      });
      return this.form.status;
    },
  },
  watch: {},
};
</script>

<style></style>
